import { lazy, Suspense } from "react";
import { Loading } from "../../elements/Loading";
import { AudienceExportDownload } from "./AudienceExportCells";
import { AudienceExportSize } from "./AudienceExportCells";

// Lazy so the drag and drop library isn't loaded behind every record page.
const Body = lazy(() => import("./AudienceBody"));

export function AudienceBody() {
  return (
    <Suspense
      fallback={
        <div className="flex-grow-1 d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      }
    >
      <Body />
    </Suspense>
  );
}

export { AudienceExportDownload, AudienceExportSize };
